import { endpointIdFactory } from '@seccl/api-swr';
import { FirmManagementApi } from '@seccl/client';

import { apiFactory } from '../../apiFactory';

const firmApiIds = endpointIdFactory('firm', FirmManagementApi);

/** Controller factory for accessing endpoint hooks */
export const firmApi = apiFactory.createAxiosOpenApiController(firmApiIds.controllerKey, FirmManagementApi);
